import { CustomLink, DashboardDataCard, DateDistanceDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { createDataTable } from 'components/DataTable';
import React, { useState } from 'react';
import { getBygrData, getBygrVisitData, getNewProjects } from 'services/statistics';
import { BygrProject } from 'types';
import { useAsyncStateWithIsLoading } from 'utils/hooks';
import theme from './BygrStatisticsDashboard.module.scss';
import PrimaryCard from './PrimaryCard';
import StatisticsSharedCards from './StatisticsSharedCards';

interface BygrStatisticsDashboardProps {}

const ProjectTable = createDataTable<BygrProject>();

const BygrStatisticsDashboard: React.FC<BygrStatisticsDashboardProps> = (props) => {
    const [data] = useAsyncStateWithIsLoading(() => getBygrData(), [], null);
    const [visit] = useAsyncStateWithIsLoading(() => getBygrVisitData(), [], null);
    const [newProjects] = useAsyncStateWithIsLoading(() => getNewProjects(), [], null);
    const [tableState, setTableState] = useState(ProjectTable.getInitialState('id'));
    return (
        <div className={theme.dashboardContainer}>
            <PrimaryCard title={'Rubus data'}>
                {() => (
                    <>
                        <PrimaryCard.Row label="Users">{data?.users}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Units">{data?.units}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Change Requests">{data?.changeRequests}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Cases">{data?.cases}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Products">{data?.products}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Projects">{data?.projects}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Cm Projects">{data?.cmProjects}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Am Projects">{data?.amProjects}</PrimaryCard.Row>
                        <PrimaryCard.Row label="Qm Projects">{data?.qmProjects}</PrimaryCard.Row>
                    </>
                )}
            </PrimaryCard>
            <PrimaryCard title="Unique Visit data" loading={!visit}>
                {() => (
                    <>
                        <PrimaryCard.Row label="Today">{visit?.today}</PrimaryCard.Row>
                        <PrimaryCard.Row label="7 days">{visit?.last7Days}</PrimaryCard.Row>
                        <PrimaryCard.Row label="30 days">{visit?.last30Days}</PrimaryCard.Row>
                    </>
                )}
            </PrimaryCard>
            <StatisticsSharedCards projectIds={[]} />

            <DashboardDataCard
                contentAlignment="center"
                contentClassName={theme.newProjects}
                colSpan={4}
                rowSpan={2}
                loading={!newProjects}
                title="Projects created last 14 days">
                {() => (
                    <>
                        <ProjectTable
                            hasPagination={false}
                            data={newProjects!}
                            onStateChange={setTableState}
                            state={tableState}
                            totalItemCount={newProjects?.length}
                            className="table style-3">
                            <ProjectTable.Column
                                header="Name"
                                field="name"
                                renderer={({ row, value }) => <CustomLink to={`/projects/${row.id}`}>{value}</CustomLink>}
                            />
                            <ProjectTable.Column header="Units" field="numberOfUnits" />
                            <ProjectTable.Column
                                header="Profile"
                                field="sellerProfile"
                                renderer={({ value }) => <CustomLink to={`/profiles/${value.id}`}>{value.name}</CustomLink>}
                            />

                            <ProjectTable.Column
                                header="Created"
                                field="createDate"
                                renderer={(x) => x.value && <DateDistanceDisplay value={x.value} />}
                            />
                        </ProjectTable>
                    </>
                )}
            </DashboardDataCard>
        </div>
    );
};

export default BygrStatisticsDashboard;
